if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loading_spinner = this.querySelector('.loading__spinner');
        if (loading_spinner) loading_spinner.classList.remove('hidden');

        const formData = {};
        const addOns = this.form.querySelectorAll('input.js-add-on-input[name$="[id]"]');
        const addOnQuantities = this.form.querySelectorAll('input.js-add-on-input[name$="[quantity]"]');
        const variantId = this.form.querySelector('[data-main-variant-id]')?.value;
        const variantSku = this.form.querySelector('[data-main-variant-sku]')?.value;
        const quantity = this.form.querySelector('[name="quantity"]')?.value;
        const sellingPlan = this.form.querySelector('[data-selling-plan-id]')?.value;
        const properties = document.querySelectorAll('product-customization input[name^="properties"]');

        // Build properties object from personalization form inputs
        const customizationProps = {};
        properties.forEach((property) => {
          // Extract property name from brackets (e.g., "properties[_personalization]" -> "_personalization")
          const match = property.name.match(/properties\[(.+)\]/);
          if (match && property.value) {
            customizationProps[match[1]] = property.value;
          }
        });

        // Construct form data items in reverse order to ensure the correct order of items in cart
        formData.items = [
          ...Array.from(addOns)
            .reverse()
            .map((addOn, i) => {
              return {
                id: addOn.value,
                quantity: addOnQuantities[i].value,
              };
            }),
          {
            id: variantId,
            quantity: quantity || 1,
            ...(sellingPlan ? { selling_plan: sellingPlan } : {}),
            properties: customizationProps,
          },
        ];

        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(formData);

        try {
          const data = await fetch(window.Shopify.routes.root + 'cart/add.js', config);
          const response = await data.json();

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          const byPassSliderCart = this.hasAttribute('data-bypass-slider-cart');
          const quietAdd = this.hasAttribute('data-quiet-add');
          const promotionContainer = document.querySelector('promotion-container');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response, byPassSliderCart, quietAdd);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else if (promotionContainer) {
            const success = await promotionContainer.handlePromotion();
            if (!success) {
              this.cart.renderContents(response, byPassSliderCart, quietAdd);
            }
          } else {
            this.cart.renderContents(response, byPassSliderCart, quietAdd);
          }
        } catch (e) {
          console.error(e);
          window.location = window.routes.cart_url;
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const loading_spinner = this.querySelector('.loading__spinner');
          if (loading_spinner) loading_spinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          if (text) this.submitButtonText.textContent = text;
          if (text === window.variantStrings.soldOut) {
            const product_submit_buttons = document.querySelectorAll('.product-submit-button');
            product_submit_buttons.forEach((button) => {
              button.classList.add('disabled:!tw-bg-gray');
              button.classList.add('disabled:!tw-border-gray');
            });
          }
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          const product_submit_buttons = document.querySelectorAll('.product-submit-button');
          product_submit_buttons.forEach((button) => {
            button.classList.remove('disabled:!tw-bg-gray');
            button.classList.remove('disabled:!tw-border-gray');
          });
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.submitButton.removeAttribute('disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
